import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ROUTES } from "../../constant/routes";
// import SmoothLoader from "../smoothLoader";


const SIDE_BAR_LINKS = [
  {
    route: ROUTES.PLAYGROUND,
    text: "Playground.",
  },
  {
    route: ROUTES.PAIR,
    text: "Pairs you liked.",
  },
  {
    route: ROUTES.EXPLORE,
    text: "Explore all pairs.",
  },
  {
    route: ROUTES.HELP,
    text: "Help.",
  },
];

const SIDE_BAR_FOOTER_LINKS = [
  {
    route: ROUTES.TERMS,
    text: "Terms of Use",
  },
  {
    route: ROUTES.PRIVACY_POLICY,
    text: "Privacy Policy",
  },
  {
    route: ROUTES.CONTACT,
    text: "Contact",
  },
];

const Sidebar = ({setShowSidebar}) => {
  const handleSidebarNav = () => {
    setShowSidebar(false)
  }

  return (
    <div className="sidebar-list">
      <ul>
        {SIDE_BAR_LINKS.map((item) => (
          <li className={"GA_"+ item.route.replace("/", '')} key={item.route} onClick={handleSidebarNav}>
            <NavLink to={item.route} className="circularBox" style={({ isActive }) => ({ 
                            color: isActive ? '#1A73E8' : '#8C9AAD' })}>
              {item.text}
              {/* <div className="inner-animator-landing">
                <Link to={item.route}>
                  <img src={CircularText} alt="circle" />
                </Link>
                <div className="middle-arrow">
                  <img src={RightArrow} alt="Arrow" />
                </div>
              </div> */}
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="footer-links">
        {SIDE_BAR_FOOTER_LINKS.map((item) => (
          <p key={item.route}>
            <Link to={item.route}>{item.text}</Link>
          </p>
        ))}
      </div>
      {/* <SmoothLoader /> */}
    </div>
  );
};

export default Sidebar;
